import { PRODUCT_TYPE } from "../../constants/commonConstants";

const roundUpToIncrement = (value, increment) =>
  Math.ceil(value / increment) * increment;

export const getIncrement = (requestedProductType) => {
  const incrementMap = {
    [PRODUCT_TYPE.PERSONAL_LOAN]: 50,
    [PRODUCT_TYPE.CAR_LOAN]: 1,
    [PRODUCT_TYPE.LINE_OF_CREDIT]: 100,
  };

  return incrementMap[requestedProductType] || 1;
};

// loanAmountString is expected to be either: null, undefined OR a string representation of a positive number
// if loanAmountString ever gains the ability to be negative more tests will be required
export const roundLoanAmountUp = (loanAmountString, requestedProductType) => {
  const loanAmount = parseInt(loanAmountString);
  const increment = getIncrement(requestedProductType);

  if (isNaN(loanAmount)) { // if loanAmount is not a number (i.e. "")
    return loanAmountString;
  }

  return "" + roundUpToIncrement(loanAmount, increment);
};

export const roundUpLoanAmount = (value, name, requestedProductType, setFieldValue) => {
  const loanAmount = roundLoanAmountUp(value, requestedProductType);

  setFieldValue(name, loanAmount);
};